const normalizeQueryValue = (
  value: string | null | undefined
): string | undefined => {
  if (typeof value !== "string") return undefined;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
};

const toSearchParams = (search: string | URLSearchParams): URLSearchParams => {
  return typeof search === "string" ? new URLSearchParams(search) : search;
};

export const getSegmentIdFromSearch = (
  search: string | URLSearchParams
): string | undefined => {
  return normalizeQueryValue(toSearchParams(search).get("segmentId"));
};

export const getExploreSearchFromSearch = (
  search: string | URLSearchParams
): string | undefined => {
  return normalizeQueryValue(toSearchParams(search).get("search"));
};

interface CompanyRouteContext {
  segmentId?: string;
  search?: string;
}

export const buildCompanyRouteContextSearch = ({
  segmentId,
  search,
}: CompanyRouteContext): string => {
  const params = new URLSearchParams();
  const normalizedSegmentId = normalizeQueryValue(segmentId);
  const normalizedSearch = normalizeQueryValue(search);

  if (normalizedSegmentId) {
    params.set("segmentId", normalizedSegmentId);
  }
  if (normalizedSearch) {
    params.set("search", normalizedSearch);
  }

  const query = params.toString();
  return query ? `?${query}` : "";
};
